import { PublicClientApplication, Configuration } from "@azure/msal-browser";

// MSAL Configuration
const clientId = import.meta.env.ZUDOKU_PUBLIC_AZURE_B2C_CLIENT_ID;
const tenantName = import.meta.env.ZUDOKU_PUBLIC_AZURE_B2C_TENANT_NAME;
const policyName = import.meta.env.ZUDOKU_PUBLIC_AZURE_B2C_POLICY_NAME;

const authority = `https://${tenantName}.b2clogin.com/${tenantName}.onmicrosoft.com/${policyName}`;
const redirectUri = "/oauth/callback";

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority,
    redirectUri,
    knownAuthorities: [`${tenantName}.b2clogin.com`],
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};

// Create a singleton instance of PublicClientApplication
export const msalInstance = new PublicClientApplication(msalConfig);